import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getFormattedNumber } from "../../helper/general";
import { setCartItems, setMyCartModalVisibility } from "../../store/actions";

function MyCart(props) {
  const dispatch = useDispatch();
  const myCartModalVisibility = useSelector((state) => state.myCartModalVisibility);

  const myCartHandler = (e) => {
    e.preventDefault();
    dispatch(setMyCartModalVisibility(!myCartModalVisibility));
  };

  const cartItems = useSelector((state) => state.cartItems);
  let modalClass = "canvas-sidebar cart-canvas";
  modalClass += myCartModalVisibility ? " show" : "";
  let totalAmount = 0;

  // Quantity
  const handlerProductQuantity = (product_id, mode) => {
    let tempCarts = cartItems.map((obj) => {
      if (obj.product_id === product_id) {
        let currentQuantity = obj.product_quantity || 1;
        if (mode === "p") {
          currentQuantity++;
        } else {
          currentQuantity--;
        }
        currentQuantity = currentQuantity === 0 ? 1 : currentQuantity;
        return { ...obj, product_quantity: currentQuantity };
      }
      return obj;
    });

    dispatch(setCartItems(tempCarts));
  };

  // Remove item from cart
  function handlerRemove(product_id) {
    dispatch(setCartItems(cartItems.filter((x) => x.product_id !== product_id)));
  }

  return (
    <>
      <div className={modalClass}>
        <div className="canvas-overlay"></div>
        <form className="h-100">
          <div className="card border-0 pt-5 pb-7 h-100">
            <div className="px-6 text-right">
              <span onClick={myCartHandler} className="canvas-close d-inline-block fs-24 mb-1 ml-auto lh-1 text-primary">
                <i className="fal fa-times"></i>
              </span>
            </div>
            <div className="card-header bg-transparent py-0 px-6">
              <h3 className="fs-24 mb-5">Warekorb</h3>
            </div>
            <div className="card-body px-3 pt-3 overflow-y-auto">
              {cartItems.map((element, index) => {
                const discount = element?.product_discount || 0;
                const new_price = Number(element.product_price - (discount * element.product_price) / 100).toFixed(2);
                totalAmount += Number(new_price) * Number(element.product_quantity || 1);
                let productTotal = Number(new_price) * Number(element.product_quantity || 1);
                const cover_image_url = "/media/" + element.product_slug + "/thumb" + element.cover_image;
                return (
                  <>
                    <div className="mb-3 d-flex" key={index}>
                      <a
                        href="/#"
                        onClick={(e) => {
                          handlerRemove(element.product_id);
                        }}
                        className="d-block mr-4 clickable"
                      >
                        <i className="fal fa-times"></i>
                      </a>
                      <div className="media">
                        <div className="w-70px mr-4">
                          <img src={cover_image_url} alt="Cover" />
                        </div>
                        <div className="media-body">
                          <p className="font-weight-bold text-primary mb-3 d-block">{element.product_name}</p>
                          <div className="d-flex justify-content-between">
                            <div className="input-group position-relative w-124px">
                              <a
                                href="/#"
                                onClick={(e) => {
                                  handlerProductQuantity(element.product_id, "m");
                                }}
                                className="down position-absolute pos-fixed-left-center pl-2 clickable"
                              >
                                <i className="far fa-minus"></i>
                              </a>
                              <input type="text" readOnly="true" className="w-100px px-6 text-center" value={element.product_quantity} />
                              <a
                                href="/#"
                                onClick={(e) => {
                                  handlerProductQuantity(element.product_id, "p");
                                }}
                                className="up position-absolute pos-fixed-right-center clickable"
                              >
                                <i className="far fa-plus"></i>
                              </a>
                            </div>
                            <div className="mb-0 ml-3 text-primary text-right">{getFormattedNumber(productTotal)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
            <div className="card-footer mt-auto border-0 bg-transparent px-6 pb-0 pt-5">
              <div className="d-flex align-items-center mb-4">
                <span className="font-weight-bold text-primary">Total</span>
                <span className="d-block ml-auto text-primary">{getFormattedNumber(totalAmount)} EUR</span>
              </div>
              <Link to="/checkout" className="btn btn-primary btn-block mb-2">
                Zur Kasse
              </Link>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default MyCart;
